import React, {useEffect, useState} from 'react';
import Select from 'react-select';
import {Handle} from 'reactflow';
//import {Handle} from 'react-flow-renderer';
import {Form} from '../';
import {Chatbot} from '../../states/actions';
import {useSelector, shallowEqual} from 'react-redux';
import {onSuccess, onEdit, onSetStart, onRemove, onClose, isLightColor} from '../../helpers/block-helper';
import {Link} from 'react-router-dom';
import {IntNodeComponent, InputComponent, TextareaComponent, SelectComp} from './Components'
import {createSelectNodeData} from '../../states/selectors/chatbotSelectors';



export const LoginBlock = React.memo((node) => {
  const {block, start, progress} = useSelector(createSelectNodeData(node.id), shallowEqual);
  const bot = {progress: progress || []};



  if (!block) {
    return null;
  }
  const {data} = block;

  return (
    <>
        <IntNodeComponent bot={bot} name="Login" icon="login" data={data} node={node} start={start}/>
    </>
  );
});

export const LoginEditor = ({nodeid, block, language}) => {
  // Initialize state and effects first (before any conditional returns)
  const [contentValue, setContentValue] = useState('');

  useEffect(() => {
    if (block && block.data) {
      const fieldName = language === 'en' ? 'register_content_en' : language === 'ru' ? 'register_content_ru' : 'register_content';
      setContentValue(block.data[fieldName] || '');
    }
  }, [language, block]);

  // Now check if block exists
  if (!block) {
    return null;
  }

  const {data} = block;
  const variableoptions = Chatbot.getBlockVariables();

  const handleBlur = (e) => {   
    Chatbot.setBlockData(block.id, {[e.target.name]: e.target.value});
  };

  const handleContentChange = (e) => {
    setContentValue(e.target.value);
  };

  const handleContentBlur = (e) => {
    const fieldName = language === 'en' ? 'register_content_en' : language === 'ru' ? 'register_content_ru' : 'register_content';
    Chatbot.setBlockData(block.id, {[fieldName]: contentValue});
  };


return (
  <>
              <div className='section'>Email</div>

              <SelectComp
                data={data}
                name="Prefill email with"
                dataname="prefill_email"
                placeholder="Select variable"
                options={variableoptions}
                block={block}
                value="label"
              />

              <InputComponent
                data={data}
                name="Button"
                dataname={language === 'en' ? 'email_button_en' : language === 'ru' ? 'email_button_ru' : 'email_button'}
                onBlur={handleBlur}
                language={language}
                placeholder="Jäta tühjaks, et kasutada vaikimisi tõlget"
              />

              <br/><br/>

              <div className='section'>Registration</div>

              <InputComponent 
                data={data} 
                name="Message" 
                dataname={language === 'en' ? 'register_headtext_en' : language === 'ru' ? 'register_headtext_ru' : 'register_headtext'}
                onBlur={handleBlur}
                language={language}
                placeholder="Jäta tühjaks, et kasutada vaikimisi tõlget"
              />

              <div className="mb-2">
                <textarea
                  name={language === 'en' ? 'register_content_en' : language === 'ru' ? 'register_content_ru' : 'register_content'}
                  className="form-control"
                  value={contentValue}
                  onChange={handleContentChange}
                  onBlur={handleContentBlur}
                  placeholder="Jäta tühjaks, et kasutada vaikimisi tõlget"
                  rows="3"
                />
              </div>

              <br/><br/>

              <div className='section'>Data</div>

              <>VARIABLES: </><i>firstname, lastname, phone, email, pid, client_type, business_name, business_address, business_reg_code</i>
            
              {/* 
              <InputComponent data={data} name="First name" dataname="firstname" onBlur={handleBlur}/>
              <InputComponent data={data} name="Last name" dataname="lastname" onBlur={handleBlur}/>
              <InputComponent data={data} name="Phone" dataname="phone" onBlur={handleBlur}/>
              <InputComponent data={data} name="Email" dataname="email" onBlur={handleBlur}/> */}

         
  </>
  

)
};